import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
  Grid,
  Toolbar,
  InputAdornment,
  List,
  ListItem,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit } from "react-icons/fi";
import PurchaseProduct from "../../../actions/purchaseProduct";
import Popup from "../../../components/customHelpers/Popup";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useHistory, useLocation } from "react-router-dom";
import { ListItemText } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PurchaseProductDetails from "./productProfiel";
import UpdatePurchaseListForm from "../../../components/forms/updatePurchaseListForm";
import PublishPurchaseProductForm from "../../../components/forms/publishPurchaseProductForm";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  paddingLeft: theme.spacing(6),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const headCells = [
  { id: "sku", label: "Sku" },
  { id: "price", label: "Price" },
  { id: "quantity", label: "Quantity" },
  { id: "purchaseDate", label: "Purchase Date" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  listItem: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  primaryText: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
}));

const PurchaseProductDetailPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { getProduct } = PurchaseProduct();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [productData, setProductData] = useState(null);
  const [productLists, setProductLists] = useState([]);
  const [Id, setId] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];

  useEffect(() => {
    getProductData(value);
    setId(value);
  }, [value]);

  const getProductData = (id) => {
    setValues({
      ...values,
      loading: true,
    });
    getProduct(id ? id : Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product.purchaseLists);
        setProductData(data.product);
      }
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["price", "quantity"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(productLists, headCells, filterFn);

  const totalQuantity = productLists?.reduce(
    (total, list) => total + parseInt(list.quantity),
    0
  );

  return (
    <Layout>
      <div className="card">
        <Typography variant="h6" className="page-header">
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/purchase-product");
            }}
          ></ArrowBackIcon>{" "}
          <span style={{ marginLeft: "6px" }}>Purchase Product Detail</span>
        </Typography>

        <Grid container spacing={6} columns={16}>
          <Grid item xs={6}>
            <Item>
              {productData && (
                <PurchaseProductDetails
                  product={productData}
                  getProductData={getProductData}
                ></PurchaseProductDetails>
              )}
            </Item>
          </Grid>
          <Grid item xs={4}>
            <Item>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <ListItemText
                    primary={
                      <span className={classes.primaryText}>
                        Total Quantity
                      </span>
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <ListItemText
                    primary={
                      <span className={classes.secondaryText}>
                        {totalQuantity}
                      </span>
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <ListItemText
                    primary={
                      <span className={classes.primaryText}>
                        Price At Latest
                      </span>
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <ListItemText
                    primary={
                      <span className={classes.secondaryText}>
                        {productLists[0]?.price}
                      </span>
                    }
                  />
                </Grid>
              </Grid>
            </Item>
          </Grid>
        </Grid>

        {loading ? (
          <Loading />
        ) : (
          <Paper style={{ overflowX: "auto" }}>
            <TblContainer>
              <TblHead />
              <TableBody>
                {recordsAfterPagingAndSorting().length > 0 ? (
                  recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{productData?.sku}</TableCell>
                      <TableCell>{item.price}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>
                        {new Date(item.createdAt).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            setOpenPopup(true);
                            setRecordForEdit(item);
                            setEdit(true);
                          }}
                        >
                          <FiEdit />
                        </Controls.ActionButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Norecords col={8} />
                )}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </Paper>
        )}

        <Notification notify={notify} setNotify={setNotify} />

        <Popup
          title="Purchase Product List Update Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <UpdatePurchaseListForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            getAllProducts={getProductData}
            openPopupUpdate={true}
            edite={edite}
          />
        </Popup>
      </div>
    </Layout>
  );
};

export default PurchaseProductDetailPage;
